import React from 'react';
import { isSameHour, startOfHour } from 'date-fns';
import { useStatistics } from '../queries';
import { useStatisticsContext } from '../Dashboard';
import { formatTimestamp, formatValue } from '../dates';
import { StatHeader, StatMetric, StatTooltip, StatBody, StatChart } from './StatCard';

export default function ActiveSubscribers() {
  const { unit, range } = useStatisticsContext();
  const { data, isLoading } = useStatistics('activeSubscribers');

  const activeSubscribersData = data?.map(({ timestamp, value }) => ({
    timestamp: formatTimestamp(timestamp, unit, range),
    'Active subscribers': formatValue(timestamp, value),
  }));

  const maxValue = data && Math.max(...data?.map(({ value }) => value), 0);
  const minValue = data && Math.min(...data?.map(({ value }) => value), 0);

  let currentActiveSubscribers = data?.[data.length - 1]?.value;

  if (unit === 'hour') {
    const currentHour = startOfHour(new Date());
    const currentHourData = data?.find(({ timestamp }) =>
      isSameHour(new Date(timestamp), currentHour),
    );

    if (currentHourData) {
      currentActiveSubscribers = currentHourData?.value;
    }
  }

  return (
    <div>
      <StatHeader>
        <StatMetric
          isLoading={isLoading}
          label="Active subscribers"
          tooltip={
            <StatTooltip>
              This is the total count of your active and overdue subscribers. It does not include
              trials. A subscriber with multiple subscriptions is counted as one subscriber.
            </StatTooltip>
          }
          value={currentActiveSubscribers}
        />
      </StatHeader>

      <StatBody>
        <StatChart
          isLoading={isLoading}
          data={activeSubscribersData}
          categories={['Active subscribers']}
          maxValue={maxValue}
          minValue={minValue}
        />
      </StatBody>
    </div>
  );
}
